type HomeIconProps = {
  color?: string;
};

export default function HomeIcon({ color = '#047dba' }: HomeIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
      <g id="protection_zone" data-name="protection zone">
        <rect style={{ fill: 'none', strokeWidth: 0 }} width="240" height="240" />
      </g>
      <g id="icons">
        <path
          style={{ fill: color, strokeWidth: 0 }}
          d="M158.89,26.39c-21.48-21.48-56.3-21.48-77.78,0l-46.11,46.11v157.5h75v-70h20v70h75V72.5l-46.11-46.11ZM185,210h-35v-70h-60v70h-35V80.78l61.46-61.46c1.96-1.95,5.12-1.95,7.08,0l61.46,61.46v129.22Z"
        />
      </g>
    </svg>
  );
}

HomeIcon.defaultProps = {
  color: '#047dba',
};
